<template>
  <AddFactor />
</template>

<script>
import AddFactor from '../../../components/invoice/AddFactor.vue'
export default {
  components: {
    AddFactor,
  },
}
</script>

<style scoped lang="scss">
</style>